import React from 'react';
import { useAuthStore } from '@/stores/auth.store';
import { isInstitutionMenuEnabled } from '@/lib/institution-menu-flags';
import { useInstitutionSegment } from '@/hooks/useInstitutionSegment';
import { InstitutionFeatureBlocked } from './InstitutionFeatureBlocked';

type Props = {
  /** Drapeau de menu de l’établissement (désactivable par l’admin plateforme). */
  flagKey?: string;
  /** Fonctionnalité soumise au segment ; par défaut `flagKey` (voir `lib/institution-segment.ts`). */
  feature?: string;
  children: React.ReactNode;
};

/**
 * Bloque une route si le menu correspondant est désactivé pour l’institution de l’utilisateur,
 * ou si la fonctionnalité n’existe pas pour son segment (éducation / entreprise).
 * Sans institution : pas de restriction (comportement inchangé).
 */
export function InstitutionFeatureGate({ flagKey, feature, children }: Props) {
  const user = useAuthStore((s) => s.user);
  const { isAllowed } = useInstitutionSegment();
  const flags = user?.institutionDashboardMenuFlags;

  if (!user?.institutionId) {
    return <>{children}</>;
  }

  const segmentFeature = feature ?? flagKey;
  if (segmentFeature && !isAllowed(segmentFeature)) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center p-6">
        <InstitutionFeatureBlocked reason="segment" />
      </div>
    );
  }

  if (flagKey && !isInstitutionMenuEnabled(flags, flagKey)) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center p-6">
        <InstitutionFeatureBlocked />
      </div>
    );
  }

  return <>{children}</>;
}
